<template>
  <section v-if="showAdvisorResources" class="report resources">
    <header v-if="this.$route.path !== '/app/resources'">
      <h4 v-t>Resources</h4>
    </header>
    <div class="card min">
      <a :href="advisorToolsUrl" target="_blank" class="icon-block href-plain">
        <svg width="16" height="16" viewBox="0 0 16 16">
          <path
            fill="#008579"
            d="M7,6.22430445 L7,4.22716897 C5.40899212,4.46821056 4.18965517,5.84170958 4.18965517,7.5 C4.18965517,9.32825296
            5.67174703,10.8103448 7.5,10.8103448 C9.32825297,10.8103448 10.8103448,9.32825297 10.8103448,7.5
            C10.8103448,6.58790591 10.4403348,5.73599051 9.79629736,5.1155862 L10.4900667,4.39538896 C11.3278156,5.20239636
            11.8103448,6.31337741 11.8103448,7.5 C11.8103448,9.88053771 9.88053771,11.8103448 7.5,11.8103448
            C5.11946228,11.8103448 3.18965517,9.88053771 3.18965517,7.5 C3.18965517,5.28858055 4.85500708,3.46612488
            7,3.2183439 L7,1.52053689 C3.92023474,1.77461234 1.5,4.35466812 1.5,7.5 C1.5,10.8137085 4.18629149,13.5
            7.5,13.5 C10.8137085,13.5 13.5,10.8137085 13.5,7.5 C13.5,5.80859721 12.7971695,4.23103919
            11.5818682,3.10242252 L12.262359,2.3696659 C13.6793349,3.68557223 14.5,5.5276191 14.5,7.5 C14.5,11.3659933
            11.3659933,14.5 7.5,14.5 C3.63400675,14.5 0.5,11.3659933 0.5,7.5 C0.5,3.80212348 3.36736221,0.773955273
            7,0.517582026 L7,0.5 L8,0.5 L8,6.2211802 C8.51427947,6.42016069 8.879,6.91948782 8.879,7.504 C8.879,8.26339153
            8.26339153,8.879 7.504,8.879 C6.74460847,8.879 6.129,8.26339153 6.129,7.504 C6.129,6.92252326 6.4899423,6.42534911
            7,6.22430445 Z" transform="translate(0 -.5)"
          />
        </svg>

        <span v-t>Advisor Tools</span>
      </a>
      <hr>
      <a :href="resourcesUrl" target="_blank" class="icon-block href-plain">
        <svg width="16" height="16" viewBox="0 0 16 16">
          <path fill="#008579" d="M2.5,1.75 L2.5,0.75 L12.5,0.75 L12.5,1.75 L2.5,1.75 Z M10,8 L10,6.5 L11,6.5 L11,9 L4,9
          L4,6.5 L5,6.5 L5,8 L10,8 Z M0.5,3.5 L14.5,3.5 L14.5,14.5 L0.5,14.5 L0.5,3.5 Z M1.5,4.5 L1.5,13.5 L13.5,13.5 L13.5,4.5
          L1.5,4.5 Z" transform="translate(0 -.5)"
          />
        </svg>

        <span v-t>Marketing Resource Centre</span>
      </a>
    </div>
  </section>
</template>

<script>
import '@/lib/icons/resources';
import '@/lib/icons/tools';
import getBrandConfig from '@/lib/utils/get_brand_config';

const _ = {
  brandConfig: getBrandConfig(),
};

export default {
  _,
  name: 'Resources',
  data() {
    return {
      showAdvisorResources: _.brandConfig.advisorResources,
      advisorToolsUrl: _.brandConfig.advisorToolsUrl,
      resourcesUrl: _.brandConfig.marketingResourceCentreUrl,
    };
  },
};

</script>

<style scoped lang="scss">
  a {
    padding: 0.5rem 1rem;
    margin: 0;
  }
  hr { margin: 0; }
</style>
